import { config } from '@/config'

const network = {
	lastLoadTime: null,
	id: null,
	name: '',
	userAccount: null,
	web3Wrapper: null,
	providerEngine: null,
	contractWrappers: null,
	contractAddresses: {}, // erc20Proxy, erc721Proxy, zrxToken, etherToken, exchange, assetProxyOwner, forwarder, orderValidator
}


const tokenInfo = {
	lastLoadTime: null,
	verifiedTokenList: [],
	topTokenList: [],
	tradingPairBaseList: [],
	popularTradingPairList: [],
	ERC20TokenUpdates: {},
	ZRXToken: null,
	WETHToken: null
}

const account = {
	lastLoadTime: null,
	ETHBalance: null,
	WETHBalance: null,
	ZRXBalance: null,
	balanceByAddress: {},
	allowanceByAddress: {},
	trackedTokens: [],
	trackedTokenPairs: [],
}

const relayerInfo = {
	lastLoadTime: null,
	ERC20AssetPairs: {}
}

export default {
	config,
	network,
	account,
	tokenInfo,
	relayerInfo
}
